export default {
  FarmerId: "Farmer ID",
  farmerId: "Farmer ID",
    coffeeData: {
        windBreaker: "Wind Breaker Tree",
        horticultureInfo: "Horticulture Tree",
        shadeTree: "Shade Tree",
        coffeeVariety: "Coffee Variety",
        coffeeSpecies: "Coffee Species",
        coffeeCherryQuality: "Coffee Cherry Quality",
        processingBatchQuality: "Processing Batch Quality",
        greenCoffeeQuality: "Green Coffee Quality",
        processType: "Process Type",
        buyingStation: "Buying Station",
        updateWindBreaker: "Update windBreaker Tree Type",
        addWindBreaker: "Add New windBreaker Tree Type",
        updateHorticultureInfo: "Update horticultureInfo Tree Type",
        addHorticultureInfo: "Add New horticultureInfo Tree Type",
        updateShadeTree: "Update shadeTree Tree Type",
        addShadeTree: "Add New shadeTree Tree Type",
        updateCoffeeVariety: "Update coffeeVariety Tree Type",
        addCoffeeVariety: "Add New coffeeVariety Tree Type",
        deleteVarietyTitle: "Delete Variety",
        deleteVarietyMessage: "Are you sure you want to delete Variety?",
        updateCoffeeSpecie: "Update Coffee Specie",
        deleteSpecieTitle: "Delete Specie",
        deleteSpecieMessage: "Are you sure you want to delete Specie?",
        addCoffeeSpecie: "Add New Coffee variety",
        variety: "Variety",
        selectVariety: "Select Variety",
        selectSpecie: "Select Specie",
        deleteCoffeeRecord: "Are you sure you want to delete record?",
        deleteCoffeeData: "Delete Coffee Data",
        topicRequired: "Select Topic is required",
        coffeeAddSuccess: "Coffee Specie added successfully.",
        treeTypeSuccess: "Tree type added successfully.",
        treeTypeUpdateSuccess: "Tree type updated successfully.",
        coffeeVarietySuccess: "Coffee variety added successfully.",
        coffeeSpecieSuccess: "Coffee specie updated successfully.",
        nameRequired: "Name is required",
        notFound: "No Admin Coffee data Found",
      },
      cacaoData: {
        cacao: "Cacao",
        cacaoVariety: "Cacao Variety",
        cacaoSpecies: "Cacao Species",
        cacaoWeight: "Cacao Weight",
        cacaoOverview: "Cacao Overview",
        "buysellOverview": "Buy/Sell Overview",
        cacaoType: "Cacao Type",
        deleteCacaoData: "Delete Cacao Data",
        productWeight: "Product Weight",
        productType: "Type of Product",
        productPricePerKg: "Price per KG",
        registerFermentation: "Register Fermentation",
        batchVisualIdentification: "Batch Visual Indentification",
        initialWeight: "Initial Weight",
        finalWeight: "Final Weight",
        performance: "Performance",
        fermentationPercentage: "Fermentation Percentage",
        fermetationMethod: "Fermentation Method",
        boxes: "Boxes",
        piles: "Piles",
        bags: "Bags",
        selectZone: "Select Zone",
        selectPlantation: "Select Plantation",
        deliveryMethod: "Delivery Method",
        totalPrice: "Total Price",
      },

  

  memberDataSection: {
    import: "Import",
    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Import Bulk Data",
        importButton: "Import Bulk Purchase Orders",
        title: "Bulk Purchase Orders Data Import",
        // Upload tab
        templateNote: "Download and use the below templates to bulk import purchase orders.",
        selectTemplate: "Select Template",
        templateXls: "Import XLS Format",
        downloadXls: "Download XLS Format",
        selectFile: "Select file to Upload the Data",
        dropHere: "or drag and drop here",
        fileUploaded: "The file has been uploaded successfully.",
        importantNote: "Important Note",
        importantNoteDetail:
          "Please use the provided templates above for bulk uploads. Other formats will result in failure.",
        unsupportedFileFormat: "This file format is not supported.",
        invalidFileFormat: "Please upload a valid .xlsx, .xls or .csv file using the provided template.",
        templateErrorIntro:
          "The uploaded file does not match the required template. Download the template and try again.",
        importingTitle: "Importing...",
        importingNote:
          "Your uploaded files are currently being processed.\nWe will notify you once files have been uploaded successfully.",
        // Result page
        importCompleted: "Import Completed",
        recordsReadyToImport: "records ready to import",
        tabTotalRecords: "Total Records",
        tabSuccess: "Success",
        tabIssues: "Issues",
        filterAll: "All",
        filterSuccess: "Success",
        issuesDetected: "Issues Detected",
        issuesDetectedHeading: "Discrepancy detected:",
        issuesDetectedDescription:
          "Some rows have data issues (e.g., invalid purchase date, unknown farmer, farm or coffee data). Please review and resolve these before final submission.",
        deleteRowsWithIssues: "Delete rows with Data Discrepancies",
        // Table headers
        purchaseDate: "Purchase Date",
        farmer: "Farmer",
        farm: "Farm",
        buyingStation: "Buying Station",
        coffeeQuantityQuality: "Coffee Quantity & Quality",
        plantation: "Plantation",
        coffeeSpecies: "Coffee Species",
        coffeeVariety: "Coffee Variety",
        coffeeType: "Type of Coffee",
        coffeeCherryQuantity: "Coffee Cherry Quantity",
        coffeeCherryQuality: "Coffee Cherry Quality",
        pricePerKg: "Price per Kg",
        receiptNo: "Receipt No",
        lotId: "Lot ID",
        photos: "Photos",
        // Actions / dialogs
        purchaseOrder: "Purchase Order",
        detailsTitle: "Purchase Order Detail",
        editRecord: "Edit record",
        deleteRecord: "Delete record",
        deleteRecordConfirm:
          "Are you sure you want to delete this record? This action cannot be undone.",
        deleteDiscrepancyConfirm:
          "Are you sure you want to delete all {count} row(s) with issues? This action cannot be undone.",
        cancelImportTitle: "Cancel Import",
        cancelImportConfirm:
          "Are you sure you want to cancel this import? Validated records will no longer be importable.",
        cancelImportConfirmBtn: "Cancel Import",
        importConfirm: "Import {count} valid record(s) now?",
        recordUpdatedSuccess: "Record updated successfully.",
        recordsDeletedSuccess: "Records deleted successfully.",
        importCancelledSuccess: "Import cancelled successfully.",
        genericError: "Something went wrong. Please try again.",
        noDataFound: "No data found.",
        // Edit dialog
        selectFactory: "Select Factory",
        selectFarmer: "Select Farmer",
        selectFarm: "Select Farm",
        selectPlantation: "Select Plantation",
        submit: "Submit",
        addImage: "Add Image",
        addedBy: "Added by",
        close: "Close",
        // Success dialog
        successDialogTitle: "Success Message",
        importedSuccessfully: "{count} purchase order(s) have been imported successfully.",
        // History
        historyFile: "File Name",
        historyImportedOn: "Imported On",
        historyEmpty: "No bulk import history yet.",
        statusValidating: "Validating",
        statusSuccess: "Imported",
        statusCancelled: "Cancelled",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "Purchase date is invalid.",
        errorMissingPurchaseDate: "Purchase date is missing.",
        errorMissingMemberId: "Member ID is missing.",
        errorInvalidMemberIdFormat: "Member ID format is invalid. Expected: Farmer Name - Buying Station Name - Farm ID.",
        errorInvalidFarmerName: "Farmer was not found in your organization.",
        errorInvalidBuyingStationName: "Buying station was not found in your organization.",
        errorInvalidFarm: "Farm was not found in your organization.",
        errorMissingQuantity: "Coffee cherry quantity is missing.",
        errorInvalidQuantity: "Coffee cherry quantity must be a number greater than zero.",
        errorMissingQuality: "Coffee cherry quality is missing.",
        errorInvalidQuality: "Coffee cherry quality was not recognised.",
        errorMissingPrice: "Price is missing.",
        errorInvalidPrice: "Price must be a valid number.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Invalid Purchase Date",
        chipMissingPurchaseDate: "Missing Purchase Date",
        chipMissingMemberId: "Missing Member ID",
        chipInvalidMemberIdFormat: "Invalid Member ID Format",
        chipInvalidFarmerName: "Invalid Farmer",
        chipInvalidBuyingStationName: "Invalid Buying Station",
        chipInvalidFarm: "Invalid Farm",
        chipMissingQuantity: "Missing Quantity",
        chipInvalidQuantity: "Invalid Quantity",
        chipMissingQuality: "Missing Quality",
        chipInvalidQuality: "Invalid Quality",
        chipMissingPrice: "Missing Price",
        chipInvalidPrice: "Invalid Price",
      },
    },
    processingBatchBulkImport: {
      bulkImport: "Import Bulk Processing Batches",
      title: "Bulk Import Processing Batches",
      instructions: "Upload a CSV or XLSX file using the template below. Each row creates one processing batch.",
      downloadCsv: "Download CSV template",
      downloadXlsx: "Download XLSX template",
      selectFile: "Select CSV or XLSX file",
      rowsParsed: "{count} row(s) ready to import.",
      import: "Import",
      imported: "Imported {created} of {total} batch(es).",
      failed: "{failed} row(s) failed.",
      rowError: "Row {row}",
      emptyFile: "The file has no data rows.",
      missingColumns: "Missing required column(s): {columns}",
      noBuyingStation: "No buying station selected.",
      validating: "Validating rows…",
      total: "Total",
      valid: "Valid",
      invalid: "Invalid",
      all: "All",
      statusValid: "Valid",
      statusInvalid: "Invalid",
      issues: "Issues",
      back: "Back",
      importValid: "Import {count} valid row(s)",
      done: "Done",
      rowCol: "Row",
      startDateCol: "Process Date",
      purchaseOrdersCol: "Purchase Codes",
      processTypeCol: "Process Type",
      gradeCol: "Grade",
      seasonCol: "Season",
      statusCol: "Status",
      // Edit field labels
      purchaseDateCol: "Purchase Date",
      processDateCol: "Process Date",
      parchmentCol: "Parchment (Kg)",
      bagsCol: "Bags",
      vehiclePlateCol: "Vehicle Plate",
      harvestedCol: "Harvested",
      pulpedCol: "Pulped",
      washedCol: "Washed",
      dryingStartedCol: "Drying Started",
      movedToStoreCol: "Moved to Store",
      // Upload tab
      templateNote:
        "Download and use the below templates to bulk import processing batches.",
      selectTemplate: "Select Template",
      templateCsv: "Import CSV Format",
      templateXls: "Import XLS Format",
      downloadCsvFormat: "Download CSV Format",
      downloadXls: "Download XLS Format",
      importingTitle: "Bulk Import Processing Batches",
      importingNote:
        "Your uploaded file is currently being processed.\nDon't click on cancel, close or refresh this page to avoid interruption.",
      importantNote: "Important Note",
      importantNoteDetail:
        "Please use the provided templates above for bulk import processing batches. Other formats will result in failure.",
      invalidFileFormat:
        "Please upload a valid .csv, .xlsx or .xls file using the provided template.",
      unsupportedFileFormat: "This file format is not supported.",
      templateErrorIntro:
        "The uploaded file does not match the required template. Download the template and try again.",
      // Result page
      importCompleted: "Import Completed",
      tabTotalRecords: "Total Records",
      tabSuccess: "Success",
      tabIssues: "Issues",
      filterAll: "All",
      filterSuccess: "Success",
      issuesDetected: "Issues Detected",
      issuesDetectedHeading: "Issues Detected:",
      issuesDetectedDescription:
        "Some rows have data issues (e.g., missing dates, unknown process type, invalid purchase order or parchment values). Please review and resolve these before final submission.",
      deleteRowsWithIssues: "Delete rows with issues",
      editRecord: "Edit record",
      deleteRecord: "Delete record",
      deleteRecordConfirm:
        "Are you sure you want to delete this record? This action cannot be undone.",
      deleteDiscrepancyConfirm:
        "Are you sure you want to delete all {count} row(s) with issues? This action cannot be undone.",
      cancelImportTitle: "Cancel Import",
      cancelImportConfirm:
        "Are you sure you want to cancel this import? Validated records will no longer be importable.",
      cancelImportConfirmBtn: "Cancel Import",
      importConfirm: "Import {count} valid record(s) now?",
      recordUpdatedSuccess: "Record updated successfully.",
      recordsDeletedSuccess: "Records deleted successfully.",
      importCancelledSuccess: "Import cancelled successfully.",
      genericError: "Something went wrong. Please try again.",
      noDataFound: "No data found.",
      // Edit / detail dialog
      editRecordTitle: "Edit Record",
      submit: "Submit",
      detailsTitle: "Processing Batch Details",
      close: "Close",
      // Success dialog
      successDialogTitle: "Success Message",
      importedSuccessfully:
        "{count} processing batch record(s) have been imported successfully.",
      // History table
      historyFile: "File Name",
      historyImportedOn: "Imported On",
      historyEmpty: "No bulk import history yet.",
      // Bulk import status labels
      statusValidating: "Validating",
      statusSuccess: "Imported",
      statusCancelled: "Cancelled",
      // Error-code tooltip messages
      errorCodePurchaseDateRequired: "Purchase date is required.",
      errorCodeInvalidPurchaseDate: "Purchase date format is not recognised.",
      errorCodeProcessDateRequired: "Process date is required.",
      errorCodeInvalidProcessDate: "Process date format is not recognised.",
      errorCodeUnknownProcessType: "The process type is not recognized.",
      errorCodeNoOrdersForDate: "No purchase orders found for the given purchase date.",
      errorCodeParchmentInvalid: "The parchment (Kg) value is invalid.",
      errorCodeParchmentExceedsCherry: "Parchment (Kg) cannot exceed the total coffee cherry quantity.",
      errorCodeInvalidData: "One or more fields contain invalid data.",
      // Filter chip short labels
      chipPurchaseDateRequired: "Purchase Date Required",
      chipInvalidPurchaseDate: "Invalid Purchase Date",
      chipProcessDateRequired: "Process Date Required",
      chipInvalidProcessDate: "Invalid Process Date",
      chipUnknownProcessType: "Unknown Process Type",
      chipNoOrdersForDate: "No Orders for Date",
      chipParchmentInvalid: "Invalid Parchment",
      chipParchmentExceedsCherry: "Parchment Exceeds Cherry",
      chipInvalidData: "Invalid Data",
    },
    buyingStation: "Buying Station",
    factory: "Factory",
    factories: "Factories",
    factoriesName: "Factory Name",
    factoriesProdChart: "Factories Production Chart",
    societies: "Societies",
    factoryInfo: "Factory Info",
    factoryDashboard: "Factory Dashboard",
    factoryDashboardPage: {
      title: "Factory Dashboard",
      close: "Close",
      resetFilters: "Reset Filters",
      apply: "Apply",
      monthlySupplyTrend: "Monthly Supply Trend",
      processingEfficiency: "Processing Efficiency",
      funnelChart: "Funnel Chart - Input -> Output",
      totalLoss: "Total Loss",
      noTarget: "No target set",
      ytdScope: "(YTD {year})",
      operationalEfficiency: "Operational Efficiency",
      target: "Target",
      actual: "Actual",
      farmerParticipation: "Farmer Participation - Contribution Spread",
      totalInput: "Total Input",
      totalOutput: "Total Output",
      activeFarmers: "Active Farmers",
      rawIntake: "Raw Intake (Cherry Received)",
      processing: "Processing (Cherry Processed)",
      output: "Output (Parchment Out)",
      currentPeriod: "Current Period",
      previousPeriod: "Previous Period",
      volumePerTopFarmers: "Volume per Top Farmers",
      cumulativeImpact: "Cumulative Impact (%)",
      deliveries: "Deliveries (kg)",
      operational: "Operational",
      volume: "Volume (kg)",
      cumulative: "Cumulative (%)",
      to: "to",
      ranges: {
        today: "Today",
        week: "Week",
        month: "Month",
        year: "Year",
        all: "All",
      },
    },
    continue: "Continue",
    farmerId: "Farmer ID",
    FarmerId: "Farmer ID",
    farmerName: "Farmer Name",
    farmerAddress: "Farmer Address",
    quality: "Quality",
    quantity: "Quantity",
    importAll: "Import All",
    importSelected: "Import Selected",
    fileLoaded: "File loaded successfully",
    incorrectHeaders: "Incorrect headers",
    processingBatch: "Processing Batch",
    purchaseOrder: "Purchase Order",
    buyingStationDetails: "Buying Station Details",
    buyingStationUsers: "Buying Station Users",
    activityLog: "Activity Log",
    startDate: "Start Date",
    endDate: "End Date",
    purchasingOrder: "Purchasing Order",
    totalCoffeeCherry: "Total Coffee Cherry",
    airHumidity: "Air Humidity",
    density: "Density",
    temperature: "Temperature",
    beanMoistureContent: "Bean Moisture Content",
    processType: "Process Type",
    batchRating: "Select Rating Of The Batch",
    purchaseDate: "Purchase Date",
    selectFarmer: "Select Farmer",
    selectFarmers: "Select Farmers",
    selectFarm: "Select Farm",
    selectCrop: "Select Crop",
    selectPlantation: "Select Plantation",
    coffeeVariety: "Coffee Variety",
    coffeeSpecies: "Coffee Species",
    coffeeCherryQuantity: "Coffee Cherry Quantity",
    coffeeCherryQuality: "Coffee Cherry Quality",
    coffeeType: "Type of Coffee",
    pricePerKg: "Price Per Kg",
    processingDone: "Processing Done",
    processedCoffeeOut: "Processed Coffee Out",
    processingBatchDetail: "Processing Batch Detail",
    parchmentProduced: "Parchment Produced",
    selectBatchRating: "Select Batch Rating",
    processingIsDone: "Processing is Done",
    huskProduced: "Husk has been Produced",
    huskProducedLabel: "Husk Produced",
    huskProducedRequired: "Husk produced quantity is required",
    processingDoneSelectionRequired: "Select at least parchment produced or husk produced",
    farmer: "Farmer",
    farm: "Farm",
    plantation: "Plantation",

    // Lately added
    farmers: "Farmers",
    farmLimitUsed: "Farm Limit Used",
    phoneNumber: "Phone Number",
    farmSize: "Farm Size",
    farmLocation: "Farm/Location",
    date: "Date",
    status: "Status",
    noFarmers: "No Farmers Found",
    approveReject: "Approve/Reject",
    farms: "Farms",
    crops: "Crops",
    equipment: "Equipment",
    noFarms: "No Farms Found",
    views: "View",
    selectStatus: "Select Status",
    approved: "Approved",
    rejected: "Rejected",
    reject: "Reject",
    approve: "Approve",
    cancel: "Cancel",
    add: "Add",
    describeYourReason: "Describe your reason here",
    userInformation: "User Information",
    userFarmRequest: "User Farm Request",
    userFarmInformation: "User Farm(s) Information",
    activity: "Activity",
    activityType: "Activity Type",
    farmZone: "Farm Zone",
    farmerView: "Farmer View",
    cropType: "Crop Type",
    cropVarity: "Crop Varity",
    area: "Area",
    cost: "Cost",
    geofence: "Geofence",
    map_views: "Map View",
    viewAllFarms: "View All Farms",
    farmersDetails: "Farmer Details",
    download: "Download",
    pOrder: {
      addNew: "Add New",
      viewAll: "View All",
      selectDate: "Select date",
      makeSelection: "Make a selection",
      coffeeType: "Type coffee quantity",
      enterPrice: "Enter Price",
      reqPurchaseDate: "Purchase date is required",
      reqFarmer: "Farmer is required",
      reqCoffeeQnty: "Coffee Cherry Quantity is required",
      reqPrice: "Price Per Kg is required",
      grandTotal: "GRAND TOTAL",
      selectDateRange: "Select Date Range",
      import: "Import",
      purchaseId: "Purchase Id",
      purchaseDate: "Purchase Date",
      farmerName: "Farmer Name",
      quality: "Quality",
      quantity: "Quantity",
      pricePerKg: "Price Per Kg",
      selectBuyingStation: "Select buying station",
      searchUser: "Search Users",
      purchaseListView: "Purchase List View",
      viewBy: "View by",
      typeDensity: "Type Density",
      typeTemperature: "Type temperature",
      typeWaterContent: "Type water content",
    },
    farmActivity: "Farm Activity",
    showOnMap: "Show On Map",
    farmInformation: "Farm Information",
    dateOfEntry: "Date Of Entry",
    farmID: "Farm ID",
    ownershipType: "Ownership Type",
    locationAddress: "Location Addresss",
    goalType: "Goal Type",
    totalSize: "Total Size",
    zones: "Zones",
    farmActivities: "Farm Activites",
    farmDetails: "Farm Details",
    totalFarmsRegistered: "Total Farms Registered",
    totalFarmArea: "Total Farm Area",
    totalZone: "Total Zone",
    zone: "Zone",

    totalCost: "Total Cost",
    selectFarmZone: "Select Zone/Farm",
    productionType: "Production Type",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Farms Chart",
    
    // Buying Station specific translations
    buyingStations: "Buying Stations",
    registerBuyingStation: "Register Buying Station",
    registerFactory: "Register Factory",
    loadingFactory: "Loading Factory...",
    loadingBuyingStation: "Loading Buying Station...",
    searchBuyingStation: "Search Buying Station",
    searchFactory: "Search Factory",
    searchSociety: "Search Society",
    nameAndId: "Name / ID",
    email: "Email",
    mobileNumber: "Mobile Number",
    role: "Role",
    actions: "Actions",
    view: "View",
    edit: "Edit",
    activate: "Activate",
    deactivate: "Deactivate",
    operator: "Operator",
    supplier: "Supplier",
    active: "Active",
    deactivated: "Deactivated",
    inactive: "Inactive",
    activatedSuccessfully: "Buying station activated successfully",
    deactivatedSuccessfully: "Buying station deactivated successfully",
  
    factoryActivatedSuccessfully: "Factory activated successfully",
    factoryDeactivatedSuccessfully: "Factory deactivated successfully",
    factoryRegisteredSuccessfully: "Factory registered successfully",
    factoryWithoutSocietyTitle: "No society selected",
    factoryWithoutSocietyConfirm: "Are you sure you want to create a factory without associating to a society?",
    factoryUnlinkSocietyConfirm: "Are you sure you want to remove this factory's society association?",
    yes: "Yes",
    buyingStationRegisteredSuccessfully: "Buying station registered successfully",
    registrationFailed: "Registration failed. Please try again.",
    register: "Register",
    buyingStationName: "Buying Station Name",
    buyingStationId: "Buying Station ID",
    location: "Location",
    selectOnMap: "Select on map",
    selectLocation: "Select Location",
    cooperative: "Cooperative",
    makeASelection: "Make a selection",
    addPictures: "Add Picture(s)",
    addImages: "Add Image(s)",
    addImagesOrVideos: "Add Images or Videos",
    connectedUsers: "Connected Users",
    addNewUser: "Add New User",
    primaryUser: "Primary User",
    userRole: "User Role",
    userId: "User ID",
    userName: "User Name",
    accessLevel: "Access Level",
    userNameAndId: "User Name & ID",
    userRegistrationDate: "User Registration Date",
    noConnectedUsers: "No connected users. Click \"Add New User\" to add.",
    nameRequired: "Name is required",
    invalidEmail: "Invalid email address",
    emailRequired: "Email is required",
    factoryNumberRequired: "Factory number is required",
    setTemporaryPassword: "Set Temporary Password",
    temporaryPassword: "Temporary Password",
    generateNewTemporaryPassword: "Generate New Temporary Password",
    manageBuyingStationRoles: "Manage Buying Station Roles",
    buyingStationRoles: "Buying Station Roles",
    stationRole: "Station Role",
    viewPermissions: "View Permissions",
    createNewRole: "Create New Role",
    accessScopeSingle: "Single station",
    accessScopeMultiple: "Multiple stations",
    permissionsTitle: "Permissions",
    accessScopeTitle: "Buying Station Access Scope",
    accessScopeDesc: "If checked, users with this role can switch between and manage multiple assigned buying stations. If unchecked, they are restricted to a single station.",
    accessScopeLabel: "Allow this role to access multiple buying stations",
    manageFactoryRoles: "Manage Factory Roles",
    factoryRoles: "Factory Roles",
    factoryAccessScopeTitle: "Factory Access Scope",
    factoryAccessScopeDesc: "If checked, users with this role can switch between and manage multiple assigned factories. If unchecked, they are restricted to a single factory.",
    factoryAccessScopeLabel: "Allow this role to access multiple factories",
    changeAccessLevel: "Change Access Level",
    changeAccessLevelConfirm: "Change access level for {name} to {level}?",
    temporaryPasswordHistory: "Temporary Password History",
    tempPasswordSentOn: "Temporary password was sent on: {date}",
    tempPasswordSentUpdated: "Temporary password was sent on: {date}. Password updated by User on: {updatedDate}.",
    resend: "Resend",
    resetPassword: "Reset Password",
    remove: "Remove",
    users: "Users",

    // Buying Station Details specific translations
    userDetails: "User Details",
    name: "Name",
    provinceState: "Province/State",
    villageCityTown: "Village/City/Town",
    country: "Country",
    associatedFarms: "Associated Farms",
    back: "Back",
    addPurchaseOrder: "Add Purchase Order",
    cherryCollection: "Cherry Collection",
    addCherryCollection: "Add Cherry Collection",
    search: "Search",
    orderId: "Order ID",
    farmFarmer: "Farm / Farmer",
    coffeeSpeciesVariety: "Coffee Specie & Variety",
    coffeeQtyQuality: "Coffee Quantity & Quality",
    quantityPrice: "Quantity / Price",
    delete: "Delete",
    
    // Processing Batch specific translations
    addProcessingBatch: "Add Processing Batch",
    batchId: "Batch ID",
    lots: "Lots",
    greenCoffeeOut: "Green Coffee Out",
    parchmentProducedBatchRating: "Parchment Produced & Batch Rating",
    startEndDate: "Start Date/End Date",
    completed: "Completed",
    inProcess: "In-Process",
    
    // Associated Farms specific translations
    associateFarm: "Associate Farm",
    farmNameAndId: "Farm Name & ID",
    addressOfProduction: "Address of Production",
    areaHa: "Area (ha)",
    type: "Type",
    eudrDeforestationStatus: "EUDR Deforestation Status",
    eudrDeforestationStatusTT: "EUDR Deforestation Risk Assessment Status",
    zeroNegligibleProbability: "Zero/Negligible Probability",
    assessments: "Assessments",
    riskAssessment: "Risk Assessment",
    compliant: "Compliant",
    nonCompliant: "Non-Compliant",
    pending: "Pending",
    dateOfSubmission: "Date of Submission",
    dateOfExpiry: "Date of Expiry",
    selectFarms: "Select Farms",
    reviewSelection: "Review Selection",
    next: "Next",
    reviewMappingPrompt: "You have selected {count} farm(s). Confirm to map them to this Factory.",
    confirmMapping: "Confirm Mapping",
    farmsMappedSuccess: "Farms mapped successfully",
    farmsMappedError: "Failed to map farms",
    owner: "Owner",

    confirmDialog: {
      delete: {
        title: "Delete Buying Station",
        message: "Are you sure you want to delete this buying station?",
        confirmBtn: "Delete",
      },
      activate: {
        title: "Activate",
        message: "Are you sure you want to activate this {entity}?",
        confirmBtn: "Activate",
      },
      deactivate: {
        title: "Deactivate",
        message: "Are you sure you want to deactivate this {entity}?",
        confirmBtn: "Deactivate",
      },
    },
    
    registerNewFactory: "Register New Factory",
    selectHowYouWantToProceed: "Select how you want to proceed",
    single: "Single",
    multiple: "Multiple",
    user: "User",
    createNewFactory: "Create a New Factory",
    factoryName: "Factory Name",
    factoryNumber: "Factory Number",
    society: "Society",
    factoryUsers: "Factory Users",
    factoryDetails: "Factory Details",
    updateFailed: "Update failed",
    firstName: "First Name",
    lastName: "Last Name",
    primaryEmailAddress: "Primary Email Address",
    submit: "Submit",
    downloadTemplate: "Download Template",
    templateInfo: "Download the template file to see the required format for bulk registration.",
    templateFormat: "Please provide file in CSV Format.",
    selectFileToUpload: "Select file to upload the data",
    uploadFileOrDragAndDrop: "or drag and drop here",

    greenCoffee: {
      bulkImport: {
        importButton: "Import Green Coffee in Bulk",
        title: "Bulk Green Coffee Data Import",
        breadcrumb: "Coffee Overview > Dry Milling",
        tabImport: "Import",
        tabHistory: "History",
        templateNote:
          "Download and use the below templates to bulk import green coffee.",
        selectTemplate: "Select Template",
        templateXls: "Import XLS Format",
        templateCsv: "Import CSV Format",
        importingTitle: "Bulk Green Coffee Data Import",
        importingNote:
          "Your uploaded file is currently being processed.\nDon't click on cancel, close or refresh this page to avoid interruption.",
        importCompleted: "Import Completed",
        tabTotalRecords: "Total Records",
        tabSuccess: "Success",
        tabFailed: "Failed",
        tabIssues: "Issues",
        tabDataDiscrepancies: "Data Discrepancies",
        filterAll: "All",
        filterSuccess: "Success",
        filterIssues: "Issues",
        issuesDetectedHeading: "Issues Detected:",
        issuesDetectedDescription:
          "Some lots have data issues (e.g., invalid outturn number, outturn number not existed in system). Please review and resolve these before final submission.",
        deleteLotsWithDataDiscrepancies: "Delete Lots with Data Discrepancies",
        bulkResolutionPrompt:
          "Apply a bulk resolution below, or resolve them individually in the table.",
        bulkDeleteRecordsTitle: "Delete Records with Data Discrepancies",
        bulkDeleteRecordsDescription:
          "Conflicting rows in this uploaded file will be skipped. Your existing factory records will remain untouched in the system.",
        lotId: "Lot ID",
        lotIdAndOutturn: "Lot ID & Outturn",
        grower: "Grower",
        coffeeType: "Coffee Type",
        grossAndNetWeight: "Gross Weight & Net Weight",
        issuesDetected: "Issues Detected",
        issueOutturnNumberMismatchTitle: "Outturn number mismatch:",
        issueOutturnNumberMismatchDescription:
          "This outturn does not match any existing Parchment Delivery records. Please ensure the Outturn Number was manually linked at the Factory level before re-uploading.",
        issueDuplicateOutturnNumberTitle: "Duplicate Outturn Number:",
        issueDuplicateOutturnNumberDescription:
          "Outturn number appears multiple times in this uploaded document.",
        issueMissingOutturnNumberTitle: "Missing Outturn Number:",
        issueMissingOutturnNumberDescription:
          "The uploaded row does not contain an Outturn Number. A valid unique Outturn identifier is required to match the record with the factory system.",
        issueGrowerIdentityMismatchTitle: "Grower Identity Mismatch:",
        issueGrowerIdentityMismatchDescription:
          "Outturn number is registered in our system under Grower {mobileGrowerName}, but the uploaded file assigns it to {xlsGrowerName}. Data overwrite restricted.",
        issueMissingGrowerCredentialsTitle: "Missing Grower Credentials:",
        issueMissingGrowerCredentialsDescription:
          "The record is missing the Grower Name or Grower ID. These data fields are mandatory to verify factory ownership before the batch can be reconciled.",
        editRecord: "Edit record",
        deleteRecord: "Delete record",
        downloadXls: "Download XLS Format",
        selectFile: "Select file to Upload the Data",
        dropHere: "or drag and drop here",
        importantNote: "Important Note",
        importantNoteDetail:
          "Please use the provided templates above for bulk import green coffee. Other formats will result in failure.",
        invalidFileFormat:
          "Please upload a valid .csv, .xlsx, or .xls file using the provided template.",
        unsupportedFileFormat: "This file format is not supported.",
        importFailed: "Import Failed",
        importFailedIntro:
          "The file could not be imported. Check the template format and row data, then try again.",
        templateErrorIntro:
          "The uploaded file does not match the required template. Download the CSV or XLS template and try again.",
        tryAgain: "Try Again",
        errorDetails: "Details",
        historyEmpty: "No bulk import history yet.",
        // Validation review / import flow
        validationSummaryTitle: "Validation Summary",
        recordsReadyToImport: "records ready to import",
        editRecordTitle: "Edit Record",
        growerCode: "Grower's Code",
        growerName: "Grower Name",
        greenBeansTotal: "Input Weight With Bags (Kgs)",
        selectedCount: "selected",
        deleteSelected: "Delete Selected",
        deleteRecordConfirm:
          "Are you sure you want to delete this record? This action cannot be undone.",
        deleteSelectedConfirm:
          "Are you sure you want to delete the {count} selected record(s)? This action cannot be undone.",
        deleteDiscrepancyConfirm:
          "Are you sure you want to delete all {count} lot(s) with data discrepancies? This action cannot be undone.",
        cancelImportTitle: "Cancel Import",
        cancelImportConfirm:
          "Are you sure you want to cancel this import? Validated records will no longer be importable.",
        cancelImportConfirmBtn: "Cancel Import",
        importConfirm: "Import {count} valid record(s) now?",
        recordUpdatedSuccess: "Record updated successfully.",
        recordsDeletedSuccess: "Records deleted successfully.",
        importCancelledSuccess: "Import cancelled successfully.",
        importSuccess: "Import completed successfully.",
        genericError: "Something went wrong. Please try again.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Invalid Data:",
        issueInvalidDataDescription:
          "One or more fields contain invalid data. Please review and correct them.",
        errorCodeOutturnMismatch:
          "This outturn number does not match any existing parchment delivery record.",
        errorCodeOutturnMissing: "Outturn number is missing.",
        errorCodeOutturnDuplicate:
          "This outturn number is duplicated in the file or already exists in the system.",
        errorCodeGrowerMismatch:
          "Grower name/code does not match the registered parchment delivery.",
        errorCodeGrowerMissing: "Grower name or grower code is missing.",
        errorCodeInvalidData: "One or more fields contain invalid data.",
        // History table
        historyFile: "File Name",
        historyImportedOn: "Imported On",
        historyUploadedBy: "Uploaded By",
        historyCreatedDate: "Created Date",
        historyTotalRecords: "Total Records",
        historyErrorRecords: "Error Records",
        // Bulk import status labels
        statusValidating: "Validating",
        statusSuccess: "Imported",
        statusCancelled: "Cancelled",
        // Edit record dialog
        editFieldId: "ID",
        inputWeightWithBags: "Input Weight With Bags",
        qualityControl: "Quality Control",
        submit: "Submit",
        noMillingOutputs: "No milling output details.",
        millingCleanCoffee: "Clean Coffee (Milling Output Details)",
        millingBags: "Bags (Milling Output Details)",
        millingPockets: "Pockets (Milling Output Details)",
        millingWeight: "Weight (Milling Output Details)",
        millingBulkOutturn: "Bulk Outturn (Milling Output Details)",
        millingRatio: "Ratio (Milling Output Details)",
        // Detail dialog
        detailsTitle: "Green Coffee Details",
        outturnNo: "Outturn No",
        close: "Close",
        // Success dialog
        successDialogTitle: "Success Message",
        importedSuccessfully:
          "{count} green coffee record(s) have been imported successfully.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Outturn Number Mismatch",
        chipOutturnMissing: "Outturn Number Missing",
        chipOutturnDuplicate: "Duplicate Outturn Number",
        chipGrowerMismatch: "Grower Identity Mismatch",
        chipGrowerMissing: "Missing Grower Credentials",
        chipInvalidData: "Invalid Data",
      },
      processGreenCoffee: "Process Green Coffee",
      addedBy: "Added by",
      selectProductType: "Select Product Type",
      processDate: "Process Date",
      selectProcessingBatch: "Select Processing Batch",
      selectParchmentDelivery: "Select Parchment Delivery",
      parchmentDeliveryRequired: "Parchment delivery is required",
      outturnAndDate: "Outturn Number & Delivery Date",
      lotIdAndDate: "Batch ID & Date",
      typeAndQuantity: "Type & Quantity",
      supplier: "Supplier",
      outturnNumber: "Outturn Number",
      totalInputQuantity: "Total Input Quantity (kg)",
      qualityControl: "Quality Control",
      airHumidity: "Air Humidity (value in %)",
      density: "Density (kg/cm3)",
      greenCoffeeQualityScore: "Green Coffee Quality Score",
      batchProduction: "Batch Production",
      unsortedGreenBeans: "Unsorted Green Beans (kg)",
      batchProductionDensity: "Batch Production Density (kg/cm3)",
      percentagePrimaryDefect: "Percentage Primary Defect",
      percentageSecondaryDefect: "Percentage Secondary Defect",
      greenBeans: "Green Beans",
      totalGreenBeans: "Total Green Beans (kg)",
      unitSize: "Unit Size (kg)",
      totalBags: "Total Bags",
      leftoverQuantity: "Leftover Quantity",
      leftoverQuantityDesc: "Leftover Quantity is the remaining amount that cannot form a full bag. It represents the quantity left after filling the maximum number of complete units from the total supply.",
      expiryDate: "Expiry Date",
      label: "Label",
      qualityControlButton: "Quality Control",
      valueInPercent: "value in %",
      kgCm3: "kg/cm3",
      complete: "Complete",
      editTitle: "Edit Green Coffee",
      lotIdOutturnNo: "Batch ID / Outturn No.",
      startDate: "Start Date",
      greenBeansQualityGrading: "Green Beans Quality Grading",
      totalQuantity: "Total Quantity",
      quantity: "Quantity",
      packing: "Packing",
      bag: "Bag",
      qualityScore: "Quality Score",
      noLotsYet: "No lots yet. Add quality grades from the create flow.",
      lotId: "Lot ID",
      percentage: "Percentage",
      createQualityGrade: "Create Quality Grade",
      finishGrading: "Finish Grading",
      finishGradingDesc: "Once finished you can not grade this lot again. Waste will be auto calculated after completion.",
      finishGradingButton: "Finish Grading",
      addNewQualityGrade: "Add New Quality Grade",
      totalGreenBeansExceeded: "Total graded quantity cannot exceed Total Green Beans",
      lotIdAlreadyExists: "This lot ID is already in use. Use a different lot ID.",
      toAddRecord: "to add a record.",
      noSearchResults: "No records match your search. Clear the search to see all records.",
      registeredSuccess: "Green Coffee registered successfully",
      exportNotImplemented: "Export not implemented",
      processingBatchRequired: "Processing batch is required",
      outturnAvailable: "Outturn number is available",
      outturnExists: "This outturn number already exists. Please enter a unique one.",
      outturnValidationRequired: "Please wait for outturn validation to finish or fix the outturn number.",
      outturnCheckFailed: "Could not validate outturn number. Please try again.",
      processingBatchAlreadyLinked: "This processing batch is already linked.",
      totalGreenBeansRequired: "Total green beans is required",
      enterHere: "Enter here",
      viewTitle: "Green Beans Quality Grading",
      parchmentInformation: "Parchment Information",
      processInformation: "Process Information",
      greenBeansInformation: "Green Beans Information",
      traceabilityLabel: "Traceability Label",
      waste: "Waste",
      downloadLabel: "Download Label",
      startCupping: "Start Cupping",
      cuppingHistory: "Cupping History",
      noDataFound: "No data found.",
      noParchmentBatches: "No parchment batches linked.",
      noQualityGrades: "No quality grades recorded.",
      batchId: "Batch ID",
      species: "Species",
      variety: "Variety",
      process: "Process",
      batchRating: "Batch Rating",
      humidity: "Humidity",
      totalCoffeeCherryQty: "Total Coffee Cherry Qty",
      weightBeforeProcessing: "Weight before Processing",
      numberOfBags: "Number of Bags",
      externalId: "External ID",
      qrCode: "QR Code",
      latestCuppingScore: "Latest Cupping Score",
      totalWaste: "Total Waste",
      close: "Close",
      unitSizeKgBag: "Unit Size (kg/bag)",
      grade: "Grade",
      selectGrade: "Select grade",
      quantityRequired: "Quantity is required",
      quantityMustBePositive: "Quantity must be greater than 0",
      unitSizeRequired: "Unit size is required",
      unitSizeMustBePositive: "Unit size must be greater than 0",
      gradeRequired: "Grade is required",
      labelRequired: "Label is required",
      cupping: "Cupping",
      cuppingInformation: "Cupping Information",
      cupperName: "Cupper Name",
      cuppingDate: "Cupping Date",
      enterCupperName: "Enter cupper name",
      attachFiles: "Attach File(s)",
      selectFilesToUpload: "Select File(s) to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      lightRoast: "Light Roast",
      roastingTime: "Roasting Time",
      roastingTemperature: "Roasting Temperature",
      qualities: "Qualities",
      uniformity: "Uniformity",
      cleanCup: "Clean Cup",
      sweetness: "Sweetness",
      overall: "Overall",
      defects: "Defects",
      finalScore: "Final Score",
      sessionDetails: "Session details",
      noCuppingHistory: "No cupping history for this green coffee.",
      cuppingDataSaved: "Cupping data saved.",
      date: "Date",
      roast: "Roast",
      score: "Score",
    },
    parchmentDelivery: {
      listTitle: "Parchment Delivery",
      addParchmentDelivery: "Add Parchment Delivery",
      parchmentDeliveryIdAndOutturn: "Parchment Delivery ID & Outturn Number",
      processingBatchLot: "Processing Batch Lot",
      netWeightAndCoffeeType: "Net Weight & Coffee Type",
      deliveryDateColumn: "Delivery Date",
      statusDelivered: "Delivered",
      statusDraft: "Draft",
      selectDeliveryDate: "Select date",
      addParchmentDeliverySaved: "Parchment delivery saved successfully.",
      deleteParchmentDeliverySaved: "Parchment delivery deleted successfully.",
      deleteParchmentDeliveryFailed: "Failed to delete parchment delivery.",
      addEditComingSoon: "Add and edit screens will be available in a future update.",
      viewComingSoon: "View details will be available when connected to the API.",
      outturnNumber: "Outturn Number",
      noDataFound: "No data found.",
      viewHistory: "View History",
      historyEmpty: "No history records found.",
      historyLoadError: "Failed to load history.",
      updatedBy: "Updated By",
      bulkImport: {
        importButton: "Import bulk Parchment Deliveries",
        title: "Bulk Parchment Deliveries Data Import",
        templateNote:
          "Download and use the below templates to bulk import parchment deliveries.",
        selectTemplate: "Select Template",
        templateXls: "Import XLS Format",
        templateCsv: "Import CSV Format",
        importingTitle: "Bulk Parchment Deliveries Data Import",
        importingNote:
          "Your uploaded file is currently being processed.\nDon't click on cancel, close or refresh this page to avoid interruption.",
        importCompleted: "Import Completed",
        tabTotalRecords: "Total Records",
        tabSuccess: "Success",
        tabIssues: "Issues",
        historyEmpty: "No bulk import history yet.",
        filterAll: "All",
        filterSuccess: "Success",
        filterIssues: "Issues",
        filterLabelOutturnMismatch: "Outturn Number Mismatch",
        filterLabelDuplicateOutturn: "Duplicate Outturn Number",
        filterLabelMissingOutturn: "Outturn Number Missing",
        filterLabelGrowerMismatch: "Grower Identity Mismatch",
        filterLabelMissingGrower: "Missing Grower Credentials",
        filterLabelWeightMismatch: "Weight Mismatch",
        filterLabelMissingWeight: "Missing Weight Value",
        filterLabelDeliveryDate: "Delivery Date Mismatch",
        filterLabelBagsMismatch: "Bags Quantity Mismatch",
        issuesDetectedHeading: "Discrepancies detected:",
        issuesDetectedDescription:
          "Some lots have data issues (e.g., invalid outturn number, outturn number not existed in system). Please review and resolve these before final submission.",
        bulkResolutionPrompt:
          "Apply a bulk resolution below, or resolve them individually in the table.",
        bulkDeleteRecordsTitle: "Delete Records with Data Discrepancies",
        bulkDeleteRecordsDescription:
          "Conflicting rows in this uploaded file will be skipped. Your existing factory records will remain untouched in the system.",
        bulkOverrideFactoryTitle: "Override Factory Data with Union Data",
        bulkOverrideFactoryDescription:
          "Data from this uploaded file will become the new system record. This overwrites the original factory submissions for the conflicting rows.",
        bulkOverrideNoneResolvable:
          "No records in the current view can be bulk-overridden. Outturn and duplicate-outturn issues must be fixed in the file or resolved individually.",
        bulkOverrideSaved: "{count} record(s) updated with union data.",
        importSuccessDialogTitle: "Success Message",
        importSuccessDialogMessage:
          "{count} Parchment Deliveries have been imported successfully.",
        deleteLotsWithDataDiscrepancies: "Delete Lots with Data Discrepancies",
        deleteDataTitle: "Delete",
        deleteDataConfirmQuestion:
          "Are you sure you want to delete all {count} records with data discrepancies?",
        deleteDataConfirmQuestionIssueType:
          "Are you sure you want to delete {count} record(s) with \"{issueType}\" data discrepancies?",
        deleteDataConfirmQuestionSingle: "Are you sure you want to delete a record?",
        overwriteDataTitle: "Overwrite Data",
        overwriteDataConfirmQuestion:
          "Are you sure you want to overwrite the factory records with the data from this uploaded file?",
        overwriteDataMismatchedTitle: "Mismatched Data:",
        overwriteDataMismatchedDescription:
          "Mismatch data will be replaced with the CSV data. The factory user will receive an automated notification.",
        overwriteDataMissingTitle: "Missing/Unrecognized Data:",
        overwriteDataMissingDescription:
          "Rows missing critical IDs (like Outturn Numbers) cannot be processed and will be safely dropped from this import.",
        detailTitle: "Parchment Delivery Detail",
        parchmentDeliverySection: "Parchment Delivery",
        processingBatchLot: "Processing Batch Lot",
        processingBatchDetails: "Processing Batch Details",
        typeAndProcess: "Type & Process",
        lotIdAndDate: "Batch ID & Date",
        deliveryDate: "Delivery Date",
        season: "Season",
        growerName: "Grower's Name",
        growerCode: "Grower's Code",
        bags: "Bags",
        grossWeight: "Gross Weight",
        netWeightWithBags: "Net Weight with Bags",
        netWeight: "Net Weight",
        broker: "Broker",
        endDate: "End Date",
        totalCoffeeCherry: "Total Coffee Cherry",
        temperature: "Temperature",
        beanMoistureContent: "Bean Moisture Content",
        processType: "Process Type",
        parchmentProduced: "Parchment Produced",
        internalId: "Internal ID",
        downloadQr: "Download QR",
        downloadQrPending: "QR download will be available when connected to the API.",
        batchCompleted: "Completed",
        discrepancyResolutionTitle: "Discrepancy Resolution Required",
        discrepancyResolutionSubtitle:
          "The uploaded file contains values that differ from the factory records.",
        discrepancyResolutionPrompt: "Please select the correct value to save.",
        factoryRecord: "Factory Record",
        unionRecord: "Union Record",
        confirmAndSave: "Confirm & Save",
        resolutionSaved: "Your selections have been applied to this record.",
        lotId: "Lot ID",
        lotIdAndOutturn: "Lot ID & Outturn",
        grower: "Grower",
        coffeeType: "Coffee Type",
        issuesDetected: "Issues Detected",
        editRecord: "Edit record",
        editParchmentDeliveryTitle: "Edit Parchment Delivery",
        growerCodeFactory: "Grower's Code (Factory Code)",
        growerNameFactory: "Grower's Name (Factory Name)",
        moistureLabel: "Moisture",
        totalBagsLabel: "Total Bags",
        leftoverLabel: "Leftover",
        batchQuantity: "Quantity",
        selectProcessingBatchesTitle: "Select Processing Batch(es)",
        searchLabel: "Search",
        searchByBatchId: "Search by id",
        coffeeVarietyAndType: "Coffee Variety & Type",
        batchesSelectedSummary: "{count} Selected | {kg} kg",
        batchCoffeeTypeLine: "Coffee Type: {type}",
        filterAllCoffeeTypes: "All",
        selectAllBatches: "All",
        moisturePercent: "Moisture (%)",
        leftoverHandlingPrompt:
          "Your total weight ({totalWeight} kg) results in {bags} full bags with {leftover} kg leftover. How would you like to handle the leftover?",
        attachLeftoverTitle: "Attach Leftover",
        attachLeftoverDescription:
          "This quantity will be attached to Parchment Delivery.",
        moveToLeftoverTitle: "Move to Leftover Management",
        moveToLeftoverDescription:
          "This quantity will be stored as leftover to be combined with a future lot.",
        editRecordSaved: "Parchment delivery record updated.",
        downloadFailedRowPending:
          "Row download will be available when connected to the API.",
        downloadXls: "Download XLS Format",
        grossAndNetWeight: "Gross Weight & Net Weight",
        selectFile: "Select file to Upload the Data",
        dropHere: "or drag and drop here",
        importantNote: "Important Note",
        importantNoteDetail:
          "Please use the provided templates above for bulk import parchment deliveries. Other formats will result in failure.",
        invalidFileFormat: "Please upload a valid .xlsx or .xls file using the provided template.",
        unsupportedFileFormat: "This file format is not supported.",
        importFailed: "Import Failed",
        importFailedIntro:
          "The file could not be imported. Check the template format and row data, then try again.",
        templateErrorIntro:
          "The uploaded file does not match the required template. Download the XLS template and try again.",
        tryAgain: "Try Again",
        saveImport: "Save Import",
        historyFileName: "File Name",
        historyTotal: "Total",
        historySuccess: "Successful",
        historyIssues: "Issues",
        historyImportedBy: "Imported By",
        historyDate: "Date",
        historyFile: "File",
        errorDetails: "Details",
        issueOutturnNumberMismatchTitle: "Outturn Number Mismatch:",
        issueOutturnNumberMismatchDescription:
          "No matching Parchment record found in the Processing Batch module.",
        issueOutturnNumberMismatchDedicatedDescription:
          "This outturn does not match any existing Parchment Delivery records. Please ensure the Outturn Number was manually linked at the Factory level before re-uploading.",
        issueDuplicateOutturnNumberTitle: "Duplicate Outturn Number:",
        issueDuplicateOutturnNumberDescription:
          "Outturn number appears multiple times in this uploaded document.",
        issueMissingOutturnNumberTitle: "Missing Outturn Number:",
        issueMissingOutturnNumberDescription:
          "The uploaded row does not contain an Outturn Number. A valid unique Outturn identifier is required to match the record with the factory system.",
        issueGrowerIdentityMismatchTitle: "Grower Identity Mismatch:",
        issueGrowerIdentityMismatchDescription:
          "Outturn number is registered in our system under Grower {mobileGrowerName}, but the uploaded file assigns it to {xlsGrowerName}. Data overwrite restricted.",
        issueMissingGrowerCredentialsTitle: "Missing Grower Credentials:",
        issueMissingGrowerCredentialsDescription:
          "The record is missing the Grower Name or Grower ID. These data fields are mandatory to verify factory ownership before the batch can be reconciled.",
        issueWeightMismatchTitle: "Weight Mismatch:",
        issueWeightMismatchDescription:
          "The uploaded net weight values do not match the expected/registered weight for this delivery.",
        issueMissingWeightValueTitle: "Missing Weight Value:",
        issueMissingWeightValueDescription:
          "The record is missing one or more required weight values (net weight / net weight with bags).",
        issueDeliveryDateMismatchTitle: "Delivery Date Mismatch:",
        issueDeliveryDateMismatchDescription:
          "The delivery date provided in the upload does not match the date registered in the system for reconciliation.",
        issueBagsQuantityMismatchTitle: "Bags Quantity Mismatch:",
        issueBagsQuantityMismatchDescription:
          "The number of bags in the uploaded file does not match the registered factory bag count.",
        outturnDiscrepancyTooltip:
          "Unrecognized Outturn Number. No matching Parchment Delivery record found.",
        tabDataDiscrepancies: "Data Discrepancies",
      },
    },
    processingBatchReport: {
      reportTitle: "PROCESSING BATCH REPORT",
      purchaseOrderLots: "Purchase Order Lots",
      ratingOfTheBatch: "Rating Of The Batch",
      quantity: "Quantity",
      reportPageOf: "Page {page} of {total}",
      reportDataMissing: "Processing batch data is not available for the report.",
      downloadReportSuccess: "Processing batch report downloaded successfully.",
      downloadReportFailed: "Failed to generate processing batch report.",
    },
    processingBatchConfirm: {
      confirmDialogTitle: "Processing Batch Detail Confirmation",
      detailConfirmation: "Detail Confirmation",
      confirmBtn: "Confirm",
      qualityGradingQuantityRequired:
        "Enter parchment produced or total coffee cherry quantity before grading.",
      qualityGradingFinished: "Quality grading saved for this processing batch.",
    },
    purchaseOrderDetail: {
      confirmDialogTitle: "Purchase Order Detail Confirmation",
      detailConfirmation: "Detail Confirmation",
      confirmBtn: "Confirm",
      qualityGradingTitle: "Green Coffee Quality Grading",
      chartUngraded: "Ungraded",
      qualityGradingFinished: "Quality grading saved for this purchase order.",
      detailTitle: "Purchase Order Detail",
      sectionTitle: "Purchase Order",
      lotId: "Lot ID",
      unitSizeLabel: "Unit Size",
      unitSizeBagPlaceholder: "Enter quantity in a bag",
      photos: "Photos",
      lotInformation: "Lot Information",
      farmSlashZone: "Farm/Zone",
      pricePerUnit: "Price per unit",
      reportTitle: "PURCHASE ORDER REPORT",
      reportPageOf: "Page {page} of {total}",
      reportDataMissing: "Purchase order data is not available for the report.",
      downloadReport: "Download Report",
      downloadReportPending: "Report download will be available when connected to the API.",
      downloadReportSuccess: "Purchase order report downloaded successfully.",
      downloadReportFailed: "Failed to generate purchase order report.",
      qualityControlPending: "Quality control will be available when connected to the API.",
      deleteSuccess: "Purchase order deleted successfully.",
      fetchFailed: "Error fetching purchase orders.",
      idPlaceholder: "ID not available",
    },
  },
}